<template>
	<div class="machine-renewal">
		<el-dialog
			:modal-append-to-body="true"
			:append-to-body="true"
			:title="$t('userRecharge.title')"
			:visible.sync="dialogRecharge"
			width="40%"
			top="9vh"
			@closed="closeDialog"
			@open="openDialog"
			:close-on-click-modal="false">
			<!-- TAB导航开始 -->
			<template>
				<el-steps :active="stepsActive" align-center :process-status="process">
					<el-step
						:title="$t('userRecharge.step1')"
						icon="el-icon-edit"></el-step>
					<el-step
						v-if="payActive == 0"
						:title="$t('userRecharge.step2')"
						icon="el-icon-postcard"></el-step>
					<el-step
						v-if="payActive == 1"
						:title="$t('userRecharge.step21')"
						icon="el-icon-postcard"></el-step>
					<el-step
						v-if="payActive == 3"
						:title="$t('userRecharge.step3')"
						icon="el-icon-upload"></el-step>
					<el-step
						:title="$t('userRecharge.step4')"
						icon="el-icon-picture"></el-step>
				</el-steps>
			</template>
			<!-- TAB导航结束 -->

			<!-- 充值内容开始 -->
			<template>
				<!-- 充值信息 -->
				<div v-if="stepsActive === 0" class="content" v-loading="loading">
					<div class="title">
						<div class="el-alert--info renew-info">
							<div>
								<p>{{ $t("userRecharge.hello") }}！{{ nickName }}</p>
								<div class="renew-text">
									{{ $t("userRecharge.renewL") }}
								</div>
							</div>
							<div class="renew-tip">
								<div class="renew-price">
									{{ $t("userRecharge.total") }}：{{ price
									}}<span style="margin-left: 2px">($)</span>
								</div>
							</div>
						</div>
					</div>
					<div class="tip">
						<el-alert
							:title="$t('userRecharge.note2')"
							:description="$t('userRecharge.description')"
							type="warning"
							:closable="false">
						</el-alert>
					</div>
				</div>

				<!-- 支付方式 -->
				<div
					v-if="stepsActive === 1"
					class="content"
					v-loading="fullscreenLoading">
					<!-- 支付方式选择TAB -->
					<div style="width: 100%; display: flex; text-align: center">
						<div
							:class="payActive == 1 ? 'tablock active' : 'tablock'"
							@click="handlePayTab(1)"
							style="width: 50%; margin-right: 20px">
							{{ $t("userRecharge.step21") }}
						</div>
						<div
							:class="payActive == 3 ? 'tablock active' : 'tablock'"
							@click="handlePayTab(3)"
							style="width: 50%">
							{{ $t("userRecharge.huikuan") }}
						</div>
					</div>
					<el-row v-if="payActive == 1" style="margin-top: 20px">
						<el-col :span="24" style="text-align: center">
							<div v-if="qrCode" class="paypal">
								<div class="title">{{ $t("myWallet.paypaltip") }}</div>
								<img :src="'data:image/png;base64,' + qrCode" style="" />
								<a
									:href="hrefurl"
									target="_blank"
									style="text-decoration: underline; color: #409eff"
									><div style="line-height: 50px">
										{{ $t("common.dianwo") }}
									</div></a
								>
							</div>
						</el-col>
					</el-row>
					<div v-if="payActive == 3" class="remittance-section">
						<!-- 汇款信息卡片 -->
						<div class="remittance-info-card">
							<div class="card-header">
								<i class="el-icon-bank-card"></i>
								<span>{{ $t("userRecharge.information") }}</span>
							</div>
							<div class="card-body">
								<div class="info-row">
									<div class="info-item">
										<label>Account No:</label>
										<span>{{ payConfig.accountNo }}</span>
									</div>
									<div class="info-item">
										<label>Name:</label>
										<span>{{ payConfig.name }}</span>
									</div>
								</div>
								<div class="info-row">
									<div class="info-item full-width">
										<label>Beneficiary Bank Name:</label>
										<span>{{ payConfig.beneficiaryBankName }}</span>
									</div>
								</div>
								<div class="info-row">
									<div class="info-item full-width">
										<label>Beneficiary Bank Address:</label>
										<span>{{ payConfig.beneficiaryBankAddress }}</span>
									</div>
								</div>
								<div class="info-row">
									<div class="info-item">
										<label>Beneficiary Bank Code:</label>
										<span>{{ payConfig.beneficiaryBankCode }}</span>
									</div>
									<div class="info-item">
										<label>SWIFT:</label>
										<span>{{ payConfig.swiftAddress }}</span>
									</div>
								</div>
							</div>
						</div>

						<!-- 上传回执区域 -->
						<div class="upload-section">
							<div class="upload-header">
								<i class="el-icon-upload"></i>
								<span>{{ $t("userRecharge.receipt") }}</span>
							</div>
							<el-upload
								:class="['remittance-upload', { 'has-file': fileList.length > 0 }]"
								ref="upload"
								:action="uploadUrl"
								:headers="headers"
								accept=".jpg,.png"
								:limit="limit"
								:list-type="'picture-card'"
								:file-list="fileList"
								:on-success="handleSuccess"
								:before-upload="beforeUpload"
								:on-remove="handleRemove"
								:on-error="handleError"
								:on-exceed="handleExceed">
								<i class="el-icon-plus"></i>
							</el-upload>
							<el-alert
								:description="$t('userRecharge.tip')"
								type="warning"
								:closable="false"
								show-icon
								class="upload-tip">
							</el-alert>
						</div>

						<!-- 底部提示 -->
						<div class="tip">
							<el-alert
								:title="$t('userRecharge.note2')"
								:description="$t('userRecharge.description')"
								type="warning"
								:closable="false">
							</el-alert>
						</div>
					</div>
				</div>

				<!-- 充值结果 -->
				<div v-if="stepsActive === 2" class="content">
					<div class="renew-result">
				<div :class="['result', localResult]"></div>
				<div class="result-text">
					<div class="title">{{ localResultText }}</div>
							<div class="content">
								{{ rechargeContent() }}
							</div>
						</div>
					</div>
					<div class="tip">
						<el-alert
							:title="$t('userRecharge.note2')"
							:description="$t('userRecharge.description')"
							type="warning"
							:closable="false"></el-alert>
					</div>
				</div>
			</template>
			<!-- 充值内容结束 -->

			<!-- 底部导航开始 -->
			<template>
				<!-- 充值信息 -->
				<div v-if="stepsActive === 0" slot="footer" class="dialog-footer">
					<el-button @click="cancel('')">{{ $t("common.cancel") }}</el-button>
					<el-button type="primary" @click="submitForm()">{{
						$t("renewalRecord.do")
					}}</el-button>
				</div>

				<!-- 支付方式 -->
				<div v-if="stepsActive === 1" slot="footer" class="dialog-footer">
					<el-button @click="cancel('')">{{ $t("common.cancel") }}</el-button>
					<!-- <el-button type="primary" v-if="payActive == 1" @click="submitForm()">{{$t('common.finnialpay')}}</el-button> -->
					<el-button
						type="primary"
						v-if="payActive == 3"
						@click="submitForm()"
						>{{ $t("renewalRecord.next") }}</el-button
					>
				</div>

				<!-- 充值结果 -->
				<div v-if="stepsActive === 2" slot="footer" class="dialog-footer">
					<el-button type="primary" @click="submitForm()">{{
						$t("common.finnial")
					}}</el-button>
				</div>
			</template>
			<!-- 底部导航结束 -->
		</el-dialog>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import config from "@/http/config";
let daojishi = "";
export default {
	name: "UserRecharge",
	props: {
		nickName: {
			type: String,
			default: "",
		},
		price: {
			type: Number,
			default: 0,
		},
		dialogRecharge: Boolean,
		confirmRenew: Object,
		stepsActive: {
			type: Number,
			default: 0,
		},
		orderId: {
			type: String,
			default: "",
		},

		process: {
			type: String,
			default: "process",
		},
		state: {
			type: [String, Number],
			default: "0",
		},
	},
	data() {
		return {
			loading: false,
			fullscreenLoading: false,
			payActive: 1,
			qrCode: "",
			hrefurl: "",
			payOrderId: "",
			payConfig: {},
			uploadUrl: config.baseUrl + this.$url.Upload.renew,
			image: "",
			limit: 1,
			isOpen: false,
			localResult: "el-icon-info",
			localResultText: "",
			fileList: []
		};
	},
	computed: {
		...mapGetters(["token"]),
		headers() {
			return { token: this.token };
		}
	},
	methods: {
		/* 支付方式切换 */
		handlePayTab(index) {
			this.payActive = parseInt(index);
			if (parseInt(index) == 1) {
				// 开启监听订单支付状态
				this.listenOrder();
			}
		},
		// 弹窗打开触发
		openDialog() {
			this.isOpen = true;
			this.rentState();
			if (this.stepsActive == 1 && this.payActive == 1) {
				this.fullscreenLoading = true;
			} else {
				this.loading = true;
			}
			// 获取线下汇款信息
			this.$api
				.request(this.$url.RechargeRecord.getPayConfig, this.$method.get)
				.then(res => {
					if (res.code === 0) {
						this.payConfig = res.data;
						let orderId = this.payOrderId || this.orderId;
						// 查看详情
						if (this.stepsActive == 1 && this.payActive == 1) {
							// 获取PayPal后台充值二维码
							this.$api
								.request(
									this.$url.RechargeRecord.rechargePAYPAL,
									this.$method.get,
									{
										orderId: orderId,
										orderType: "MONEY_ORDER",
									}
								)
								.then(res => {
									if (res.code === 0) {
										this.hrefurl = res.data.href;
										this.qrCode = res.data.url;
										this.fullscreenLoading = false;
										// 开启监听订单支付状态
										this.listenOrder();
									}
								});
						} else {
							this.loading = false;
						}
					}
				})
				.catch(() => {
					this.loading = false;
				});
		},
		// 弹窗关闭触发
		closeDialog() {
			this.cancel(this.stepsActive > 0 ? "up" : "");
			this.stepsActive = 0;
			this.isOpen = false;
			this.image = "";
			this.fileList = [];
			this.$refs.upload && this.$refs.upload.clearFiles();
		},
		// 弹窗取消触发
		cancel(state) {
			if (daojishi) {
				clearTimeout(daojishi);
			}
			this.$emit("cancelRecharge", false, state);
		},
		// 下一步、已付款、上传回执触发
		submitForm() {
			if (this.stepsActive === 0) {
				this.loading = true;
				// 下一步：生成充值订单后切换至支付方式
				this.$api
					.request(this.$url.RechargeRecord.insert, this.$method.post, {
						price: this.price,
					})
					.then(res => {
						if (res.code === 0) {
							// 当前充值订单号
							this.orderNumber = res.data;
							this.payOrderId = res.data.id;
							// 获取PayPal后台充值二维码
							this.$api
								.request(
									this.$url.RechargeRecord.rechargePAYPAL,
									this.$method.get,
									{
										orderId: this.payOrderId,
										orderType: "MONEY_ORDER",
									}
								)
								.then(res => {
									this.loading = false;
									if (res.code === 0) {
										this.hrefurl = res.data.href;
										this.qrCode = res.data.url;
										this.stepsActive = parseInt(this.stepsActive) + 1;
										// 开启监听订单支付状态 (待开发)
										this.listenOrder();
									}
								});
						} else {
							this.loading = false;
						}
					});
			} else if (this.stepsActive === 1) {
				if (parseInt(this.payActive) == 3) {
					// 线下汇款进入
					if (this.image) {
						this.fullscreenLoading = true;
						this.$api
							.request(this.$url.RechargeRecord.update, this.$method.put, {
								id: this.payOrderId,
								img: this.image,
							})
							.then(res => {
							if (res.code === 0) {
								this.stepsActive = parseInt(parseInt(this.stepsActive) + 1);
								this.state = 1;
								this.localResult = "el-icon-info";
								this.localResultText = this.$t("userRecharge.wait");
							}
								this.fullscreenLoading = false;
							});
					} else {
						this.$message.warning(this.$t("userRecharge.receipt"));
					}
				}
			} else if (this.stepsActive === 2) {
				/* 充值结果确认已完成 */
				this.$emit("cancelRecharge", false, "");
			}
		},
		// 检测订单付款状态
		listenOrder() {
			if (parseInt(this.payActive) != 1 || this.isOpen === false) {
				return false;
			}
			let orderId = this.payOrderId || this.orderId;
			this.$api
				.request(this.$url.RechargeRecord.getById, this.$method.get, {
					id: orderId,
				})
				.then(res => {
					if (res.code === 0) {
						if (res.data) {
							let state = res.data.payState;
							if (parseInt(state) > 0) {
							// 切换至充值结果
							if (parseInt(state) == 1) {
								// 已完成付款，充值核实中
								this.stepsActive = parseInt(this.stepsActive) + 1;
								this.state = "1";
								this.localResult = "el-icon-info";
								this.localResultText = this.$t("userRecharge.wait");
							} else if (parseInt(state) == 2) {
								// 已完成付款，充值已完成
								this.stepsActive = parseInt(this.stepsActive) + 1;
								this.state = "2";
								this.localResult = "el-icon-info";
								this.localResultText = this.$t("userRecharge.success");
							} else if (parseInt(state) == 0) {
								// 申请充值中
								this.$message.warning(this.$t("common.qxwcpay"));
							}
							} else {
								daojishi = setTimeout(() => {
									clearTimeout(daojishi);
									this.listenOrder();
								}, 1500);
							}
						} else {
							daojishi = setTimeout(() => {
								clearTimeout(daojishi);
								this.listenOrder();
							}, 1500);
						}
					} else {
						daojishi = setTimeout(() => {
							clearTimeout(daojishi);
							this.listenOrder();
						}, 1500);
					}
				});
		},
		// 文件超出限制
		handleExceed() {
			this.$message.warning(this.$t("userRecharge.onlyOneFile"));
		},
		// 文件上传成功钩子
		handleSuccess(res, file) {
			if (res.code === 0) {
				this.image = res.data;
				file.url = res.data;
				this.fileList = [{ name: file.name, url: res.data }];
			} else {
				this.$message.error(this.$t("userRecharge.receiptFail"));
				this.$refs.upload.clearFiles();
				this.fileList = [];
			}
		},
		// 文件上传前触发
		beforeUpload(file) {
			const isJPG =
				file.type === "image/jpeg" ||
				file.type === "image/jpg" ||
				file.type === "image/png";
			const isLt2M = file.size / 1024 / 1024 < 1;

			if (!isJPG) {
				this.$message.error(this.$t("userRecharge.imgType"));
			}
			if (!isLt2M) {
				this.$message.error(this.$t("userRecharge.imgSize") + "1M");
			}
			return isJPG && isLt2M;
		},
		// 文件移除触发
		handleRemove() {
			this.image = "";
			this.fileList = [];
		},
		// 文件上传错误触发
		handleError(err) {
			this.$message.error(err.msg ? err.msg : this.$t("userRecharge.error"));
		},
		// 获取充值状态
		rentState() {
			if (this.state == "1") {
				this.localResult = "el-icon-info";
				this.localResultText = this.$t("userRecharge.wait");
			} else if (this.state == "2") {
				this.localResult = "el-icon-success";
				this.localResultText = this.$t("userRecharge.success");
			} else if (this.state == "3") {
				this.localResult = "el-icon-error";
				this.localResultText = this.$t("userRecharge.fail");
			} else {
				this.localResult = "el-icon-error";
				this.localResultText = this.$t("userRecharge.expired");
			}
		},
		// 获取充值结果信息
		rechargeContent() {
			if (this.state == "1") {
				return this.$t("userRecharge.content");
			} else if (this.state == "2") {
				return this.$t("userRecharge.content2");
			} else if (this.state == "3") {
		return this.confirmRenew ? this.confirmRenew.failure : '';
			} else {
				return this.$t("userRecharge.content3");
			}
		},
	},
};
</script>

<style lang="scss" scoped>
@import "~@/assets/renew/iconfont.css";
.machine-renewal .title {
	margin-bottom: 20px;
}
.machine-renewal {
	.el-alert {
		color: #515a6e;
		.el-alert__description {
			color: #515a6e;
		}
	}
	.renew-info {
		padding: 10px;
		border-radius: 4px;
		overflow: hidden;
	}
	.el-alert--info {
		border: 1px solid #abdcff;
		background-color: #f0faff;
	}
	.el-alert--success {
		border: 1px solid #8ce6b0;
		background-color: #edfff3;
	}
	.el-alert--warning {
		border: 1px solid #ffd77a;
		background-color: var(--vtm-warn-soft);
	}
	.renew-text {
		text-indent: 20px;
		margin: 8px 0;
	}
	.renew-num {
		margin: 0 5px;
		font-size: 16px;
		font-weight: bold;
		color: #409eff;
	}
}
.machine-renewal .price {
	font-weight: 500;
	font-size: 28px;
	color: #ff3333;
	margin-bottom: 5px;
}
.machine-renewal .grid-content {
	padding: 20px;
	position: relative;
	.renew {
		text-align: center;
		border-radius: 8px;
		border: 1px solid #ebeef5;
		padding: 20px;
		cursor: pointer;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
		transition: all 0.3s ease;
		position: relative;
		overflow: hidden;
		.iconfont {
			font-size: 65px;
			color: #909399;
			display: block;
			margin-bottom: 10px;
		}
	}
	.renew:hover {
		transform: translateY(-10px);
		border: 1px solid #ffcc66;
	}
	.active {
		border: 1px solid #ffcc66;
		.iconfont {
			color: #ffcc66;
		}
	}
	.renew-time {
		font-size: 14px;
		margin-bottom: 20px;
		color: #303133;
	}
	.line {
		position: relative;
	}
	.line:before {
		content: "";
		width: 100%;
		height: 1px;
		background-color: #c0c4cc;
		/*如果不使用background-color，也可以使用border-top: 1px solid #F00;*/
		-webkit-box-sizing: border-box;
		-moz-box-sizing: border-box;
		box-sizing: border-box;
		position: absolute;
		right: 0;
		bottom: 0;
		left: 0;
		-webkit-transform: scaleY(0.5);
		-moz-transform: scaleY(0.5);
		transform: scaleY(0.5);
	}
	.content {
		padding-top: 20px;
	}
}
.machine-renewal .tip {
	margin-top: 10px;
}
.machine-renewal .top {
	position: absolute;
	background: #ff6633;
	color: #ffffff;
	height: 50px;
	line-height: 70px;
	width: 150px;
	text-align: center;
	top: -15px;
	right: -65px;
	transform: rotate(45deg);
}

.machine-renewal .renew-tip {
	display: flex;
	justify-content: space-between;
	margin-top: 15px;
	height: 30px;
	line-height: 30px;
}
.machine-renewal .renew-price {
	font-size: 18px;
	color: #ff3333;
}
.machine-renewal .el-steps {
	margin-bottom: 20px;
}
/* 线下汇款区域样式 */
.remittance-section {
	margin-top: 20px;
}

.remittance-info-card {
	background: #f0faff;
	border: 1px solid #abdcff;
	border-radius: 8px;
	margin-bottom: 20px;
	overflow: hidden;
}

.remittance-info-card .card-header {
	background: #e6f7ff;
	padding: 12px 20px;
	font-size: 16px;
	font-weight: 500;
	color: #1890ff;
	border-bottom: 1px solid #abdcff;
	display: flex;
	align-items: center;
	gap: 8px;
}

.remittance-info-card .card-header i {
	font-size: 18px;
}

.remittance-info-card .card-body {
	padding: 20px;
}

.remittance-info-card .info-row {
	display: flex;
	gap: 40px;
	margin-bottom: 16px;
}

.remittance-info-card .info-row:last-child {
	margin-bottom: 0;
}

.remittance-info-card .info-item {
	flex: 1;
	display: flex;
	flex-direction: column;
	gap: 4px;
}

.remittance-info-card .info-item.full-width {
	flex: 0 0 100%;
}

.remittance-info-card .info-item label {
	color: #606266;
	font-size: 13px;
	font-weight: 500;
}

.remittance-info-card .info-item span {
	color: #303133;
	font-size: 14px;
	word-break: break-all;
}

/* 上传区域样式 */
.upload-section {
	background: #fafafa;
	border: 1px solid #e4e7ed;
	border-radius: 8px;
	padding: 20px;
	margin-bottom: 20px;
}

.upload-section .upload-header {
	font-size: 16px;
	font-weight: 500;
	color: #303133;
	margin-bottom: 16px;
	display: flex;
	align-items: center;
	gap: 8px;
}

.upload-section .upload-header i {
	font-size: 18px;
	color: #409eff;
}

.remittance-upload ::v-deep .el-upload--picture-card {
	width: 120px;
	height: 120px;
	line-height: 120px;
}

.remittance-upload ::v-deep .el-upload-list--picture-card .el-upload-list__item {
	width: 120px;
	height: 120px;
}

.remittance-upload ::v-deep .el-upload--picture-card i {
	font-size: 28px;
	color: #8c939d;
}

/* 当已有文件时隐藏上传按钮 */
.remittance-upload.has-file ::v-deep .el-upload--picture-card {
	display: none;
}

.upload-section .upload-tip {
	margin-top: 12px;
}

.upload-section .upload-tip ::v-deep .el-alert__description {
	font-size: 12px;
}
.machine-renewal .result {
	margin: 50px auto 30px;
	text-align: center;
	display: block;
	font-size: 120px;
}
.machine-renewal .el-icon-info {
	color: #409eff;
}
.machine-renewal .el-icon-success {
	color: #67c23a;
}
.machine-renewal .el-icon-error {
	color: #f56c6c;
}
.machine-renewal .renew-result {
	padding: 0 100px;
	text-align: center;
	font-size: 16px;
	.result-text .title {
		font-size: 24px;
		color: #303133;
	}
	.content {
		color: #909399;
	}
}
.el-dialog__body {
	padding: 20px;
}
.el-dialog__footer {
	padding: 0 20px 20px 20px;
}
.tablock {
	width: 55%;
	height: 40px;
	line-height: 40px;
	margin: 0 auto;
	font-size: 16px;
	cursor: pointer;
	border-radius: 5px;
	border: 1px solid #606266;
}
.active {
	background-color: #409eff;
	border: 1px solid #409eff;
	color: white;
}
.paypal {
	width: 99.5%;
	border-radius: 5px;
	border: 1px solid #409eff;
	background-color: #f0faff;
	margin: 0 auto;
}
.paypal .title {
	text-align: center;
	line-height: 80px;
	margin-bottom: 0;
}
.paypal img {
	width: 200px;
	height: 200px;
	margin: 0 auto;
	display: block;
}
</style>
